var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18087_4425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7557 18.5778L14.7815 13.6036C16.137 11.9458 16.8035 9.83038 16.643 7.69494C16.4826 5.5595 15.5075 3.56742 13.9195 2.13074C12.3315 0.694065 10.252 -0.0772832 8.11119 -0.0237567C5.9704 0.0297698 3.93207 0.904076 2.41783 2.41832C0.903588 3.93256 0.0292815 5.97088 -0.024245 8.11168C-0.0777715 10.2525 0.693577 12.3319 2.13025 13.92C3.56693 15.508 5.55901 16.4831 7.69445 16.6435C9.8299 16.804 11.9453 16.1375 13.6032 14.782L18.5773 19.7561C18.7345 19.9079 18.945 19.9919 19.1635 19.99C19.382 19.9881 19.591 19.9005 19.7455 19.746C19.9 19.5915 19.9877 19.3825 19.9895 19.164C19.9914 18.9455 19.9075 18.735 19.7557 18.5778ZM8.33315 15.0003C7.01461 15.0003 5.72568 14.6093 4.62935 13.8768C3.53302 13.1442 2.67854 12.103 2.17395 10.8849C1.66937 9.66669 1.53735 8.32625 1.79458 7.03304C2.05182 5.73983 2.68676 4.55195 3.61911 3.61959C4.55146 2.68724 5.73934 2.05231 7.03255 1.79507C8.32576 1.53784 9.6662 1.66986 10.8844 2.17444C12.1025 2.67903 13.1437 3.53351 13.8763 4.62984C14.6088 5.72617 14.9998 7.0151 14.9998 8.33364C14.9978 10.1011 14.2948 11.7957 13.045 13.0455C11.7952 14.2953 10.1007 14.9983 8.33315 15.0003Z",
    fill: "#4A5565"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18087_4425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.8207dfcc0a9af4c8687b6bafee518497.svg";
export { ForwardRef as ReactComponent };